import { PropsWithChildren, ReactElement } from 'react';

type SectionMiniCardProps = {
  icon: ReactElement;
  title: string;
  rightElement?: ReactElement;
} & PropsWithChildren;

export const SectionMiniCard = ({ icon, title, rightElement, children }: SectionMiniCardProps) => {
  return (
    <div className="flex flex-col flex-1 gap-4 bg-base-80 rounded-xl shadow-s px-3 py-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex gap-2 items-center text-l-m">
          {icon}
          <div>{title}</div>
        </div>
        {rightElement}
      </div>
      {children}
    </div>
  );
};
